import * as Unicons from '@iconscout/react-unicons';

export interface IconProps {
    iconName: string;
    className?: string;
    size?: number;
}

export const Icon = ({iconName, ...props}: IconProps) => {
    const BootstrapIcon: typeof Unicons = Unicons[iconName as keyof typeof Unicons] || null;
    if (BootstrapIcon === null) {
        return (
            <h1 className="alt-icon">
                {iconName}
            </h1>
        );
    }
    return (<BootstrapIcon {...props} />);
}